import IBusinessDetail from '@Shared.Angular/@types/core/contracts/queryModel/business/businessDetail';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import angular from 'angular';

angular.module('flowingly.runner.maintenance').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.maintenanceFlowModels, {
    url: '/flowmodels',
    params: { title: 'Maintenance - Flow Models' },
    views: {
      childcontent: {
        templateUrl:
          'Client/runner.maintenance/flowmodels/runner.maintenance.flowmodels.tmpl.html',
        controllerAs: '$ctrl',
        controller: [
          '$scope',
          function ($scope: angular.IScope) {
            $scope.$parent.$watch(
              '$ctrl.selectedBusiness',
              (value: IBusinessDetail) => {
                this.selectedBusinessId = value?.id;
              }
            );
          }
        ]
      }
    }
  });
}
